import { ITool } from '@/interfaces';
import { ToolState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { replace } from '../utils';

export const mutations = {
  setTools(state: ToolState, payload: ITool[]) {
    state.tools = payload;
  },
  setTool(state: ToolState, payload: ITool) {
    state.tools = replace(state.tools, payload);
  },
  deleteTool(state: ToolState, payload: ITool) {
    state.tools = state.tools.filter((tool: ITool) => tool.id !== payload.id);
  },
};

const { commit } = getStoreAccessors<ToolState | any, State>('');

export const commitSetTools = commit(mutations.setTools);
export const commitSetTool = commit(mutations.setTool);
export const commitDeleteTool = commit(mutations.deleteTool);
